import { GetStartedButtonProps } from 'component-library/components/buttons/GetStartedButton';
import React, { FC, ReactNode } from 'react';

import { ValuePropGridSectionLarge } from './ValuePropGridSectionLarge';
import { ValuePropGridSectionSmall } from './ValuePropGridSectionSmall';
import { ValuePropItemProps } from './ValuePropItem';

export interface ValuePropGridSectionProps {
  heading: string;
  body: ReactNode;
  image: ReactNode;
  valueProps: ValuePropItemProps[];
  Button: FC<GetStartedButtonProps>;
}

export const ValuePropGridSection: FC<ValuePropGridSectionProps> = (props) => (
  <>
    <ValuePropGridSectionSmall {...props} />
    <ValuePropGridSectionLarge {...props} />
  </>
);
